module.exports = __webpack_public_path__ + "static/media/soul-title.2e0101ce.svg";